/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_DescriptionInputs */

const ja_company_meta_description = /** @type {(inputs: Company_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`株式会社プレイブレーン（PLAYBRAIN)は、日本におけるゲームの競技シーンのニーズを理解するべく、2016年に設立されました。`)
};

const en_company_meta_description = /** @type {(inputs: Company_Meta_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN Inc. was established in 2016 to understand the needs of the competitive gaming scene in Japan.`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN Inc. was established in 2016 to understand the needs of the competitive gaming scene in Japan." |
*
* @param {Company_Meta_DescriptionInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const company_meta_description = /** @type {((inputs?: Company_Meta_DescriptionInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_DescriptionInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_description(inputs)
	return en_company_meta_description(inputs)
});